import { MarketOverviewWithNews } from '@toggle/toggle';

import { create } from '~/utils/store/createStore';

type MarketInsightsStore = {
  marketOverviewInsightGroupedByDate: Record<string, MarketOverviewWithNews[]>;
  setMarketOverviewInsightGroupedByDate: (
    marketOverviewInsightGroupedByDate: Record<string, MarketOverviewWithNews[]>
  ) => void;
  getActiveMarketInsightsGroup: (
    date: string
  ) => MarketOverviewWithNews[] | undefined;
};

export const useMarketInsightsStore = create<MarketInsightsStore>(
  (set, get) => ({
    marketOverviewInsightGroupedByDate: {},
    setMarketOverviewInsightGroupedByDate: marketOverviewInsightGroupedByDate =>
      set({ marketOverviewInsightGroupedByDate }),
    getActiveMarketInsightsGroup: date => {
      const state = get();
      const day = date.split('T')[0];
      return state.marketOverviewInsightGroupedByDate[day];
    },
  })
);
